module.exports = __webpack_public_path__ + "static/img/cont605.2f0805e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont605.jpg
// module id = wE1m
// module chunks = 0